import { SEO } from "@/components/SEO";
import { LegalLayout } from "@/components/LegalLayout";
import { company } from "@/data/company";

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="The terms and conditions governing your use of Envago Labs websites and applications."
        path="/terms"
      />
      <LegalLayout title="Terms of Service" updated="June 2026">
        <p>
          These Terms of Service ("Terms") govern your access to and use of the websites,
          applications and services provided by Envago Labs ("we", "us" or "our"), including
          Tanzeen+. By accessing or using our services, you agree to these Terms.
        </p>

        <h2>1. Use of Our Services</h2>
        <p>
          You may use our services only in compliance with these Terms and all applicable laws. You
          agree not to misuse, disrupt, or attempt to gain unauthorised access to our services or
          systems.
        </p>

        <h2>2. Intellectual Property</h2>
        <p>
          All content, trademarks, logos and software associated with Envago Labs and its products
          are owned by or licensed to us and are protected by applicable intellectual property
          laws. You may not copy, modify or distribute our content without permission.
        </p>

        <h2>3. Accounts & Subscriptions</h2>
        <p>
          Certain features, including premium subscriptions within our apps, may require an account
          or payment. You are responsible for maintaining the confidentiality of your account and
          for all activity under it. Subscription terms are disclosed at the point of purchase.
        </p>

        <h2>4. Acceptable Use</h2>
        <ul>
          <li>Do not use our services for unlawful, harmful or fraudulent purposes.</li>
          <li>Do not interfere with the security or integrity of our services.</li>
          <li>Do not reverse engineer or attempt to extract source code except as permitted by law.</li>
        </ul>

        <h2>5. Third-Party Services</h2>
        <p>
          Our services may link to or integrate with third-party services. We are not responsible
          for the content or practices of those third parties.
        </p>

        <h2>6. Disclaimer</h2>
        <p>
          Our services are provided "as is" and "as available" without warranties of any kind, to
          the fullest extent permitted by law. We do not guarantee that our services will be
          uninterrupted or error-free.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Envago Labs shall not be liable for any indirect,
          incidental or consequential damages arising from your use of our services.
        </p>

        <h2>8. Termination</h2>
        <p>
          We may suspend or terminate access to our services if you violate these Terms or use our
          services in a manner that may cause harm.
        </p>

        <h2>9. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of our services after changes
          take effect constitutes acceptance of the revised Terms.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          For questions about these Terms, contact us at{" "}
          <a href={`mailto:${company.emails.company}`}>{company.emails.company}</a>.
        </p>
      </LegalLayout>
    </>
  );
}
